export default __webpack_public_path__ + "static/media/netherlands.424ea2da.svg";